exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.jsoneditor-contextmenu div.jsoneditor-icon {\n  position: relative;\n}", ""]);

// exports
